import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"align-self":"center"}
}
const _hoisted_2 = {
  key: 1,
  class: "flex-container-col gap20"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "flex-container-col" }
const _hoisted_5 = { class: "flex-container-col" }
const _hoisted_6 = { class: "flex-container-row partner-login-links" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_error = _resolveComponent("error")!
  const _component_k_input = _resolveComponent("k-input")!
  const _component_k_button = _resolveComponent("k-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_request_account_dialog = _resolveComponent("request-account-dialog")!
  const _component_request_account_result_dialog = _resolveComponent("request-account-result-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loginInProgress)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_loader, { size: "40%" })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.loginErrorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_error, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.loginErrorMessage), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_k_input, {
              id: "txtUsername",
              ref: "refUsername",
              placeholder: _ctx.localize('EnterUsername'),
              label: _ctx.localize('Username'),
              modelValue: _ctx.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
              onInput: _ctx.onUsernameInput,
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.onEnter('username')), ["enter"]))
            }, null, 8, ["placeholder", "label", "modelValue", "onInput"]),
            _withDirectives(_createVNode(_component_error, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.localize('RequiredField')), 1)
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.showUsernameError]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_k_input, {
              id: "txtPassword",
              ref: "refPassword",
              placeholder: _ctx.localize('EnterPassword'),
              label: _ctx.localize('Password'),
              type: "password",
              modelValue: _ctx.password,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
              onInput: _ctx.onPasswordInput,
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.onEnter('password')), ["enter"]))
            }, null, 8, ["placeholder", "label", "modelValue", "onInput"]),
            _withDirectives(_createVNode(_component_error, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.localize('RequiredField')), 1)
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.showPasswordError]
            ])
          ]),
          _createVNode(_component_k_button, {
            onClick: _ctx.login,
            class: "fw mt-20"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.localize('LogIn')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, { to: "/auth/forgottenPassword" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.localize('ForgottenPassword')), 1)
              ]),
              _: 1
            }),
            _createElementVNode("a", {
              href: "#",
              class: "partner-login-create-account-link",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.showRequestAccountDialog = true), ["prevent"]))
            }, _toDisplayString(_ctx.localize('createAccount')), 1)
          ])
        ])),
    (_ctx.showRequestAccountDialog)
      ? (_openBlock(), _createBlock(_component_request_account_dialog, {
          key: 2,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showRequestAccountDialog = false)),
          onDone: _ctx.onRequestAccountDone
        }, null, 8, ["onDone"]))
      : _createCommentVNode("", true),
    (_ctx.requestAccountResult !== null)
      ? (_openBlock(), _createBlock(_component_request_account_result_dialog, {
          key: 3,
          "is-success": _ctx.requestAccountResult,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.requestAccountResult = null))
        }, null, 8, ["is-success"]))
      : _createCommentVNode("", true)
  ], 64))
}